export default __webpack_public_path__ + "static/media/success.5f5b896b.svg";